import { render, staticRenderFns } from "./InvD_Delivery.vue?vue&type=template&id=5cb91926"
import script from "./InvD_Delivery.vue?vue&type=script&lang=js"
export * from "./InvD_Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports